// ============================================================================
// marketDisputeArbiters — ДОСТУП ОПЕРАТОРОВ к обсуждению заявки.
//
// Контекстный чат читают только участники. При открытии спора добавляем в него
// сотрудников с ролями «Оператор маркетплейса», «Арбитр» и администратора
// (существующий RPC чата, вызов от участника). Ошибки — предупреждением: открытие спора не
// отменяется, но оператор может не увидеть историю (это показывается явно).
// ============================================================================

import { getSDK } from '@/store/sdkStore';
import { logSwallowed } from '@/lib/errors';
import { addConversationMember } from '@/lib/chatBridge';

const OPERATOR_ROLE = 'оператор маркетплейса';
const ADMIN_ROLE = 'admin';
const ARBITER_ROLE = 'арбитр';
const ADMIN_ROLE_RU = 'администратор';
const MAX_ARBITERS = 20;

function normalizedName(value: string): string {
  return String(value || '').trim().toLowerCase();
}

export async function ensureArbitersInConversation(conversationId: string, myId: string): Promise<string[]> {
  const warnings: string[] = [];
  if (!conversationId) return ['Обсуждение заявки не создано — операторов пригласить не удалось.'];
  try {
    const rolesRes: any = await getSDK().auth.getRoles({});
    const roleIds: string[] = [];
    for (const role of (rolesRes?.items || []) as any[]) {
      const name = normalizedName(role.name);
      if (name === OPERATOR_ROLE || name === ARBITER_ROLE || name === ADMIN_ROLE || name === ADMIN_ROLE_RU) {
        roleIds.push(String(role.id || ''));
      }
    }
    const seen = new Set<string>([myId]);
    const targets: string[] = [];
    for (const roleId of roleIds) {
      if (!roleId) continue;
      try {
        const list: any = await getSDK().entity.listEntities({ roleId });
        for (const entity of (list?.items || []) as any[]) {
          const id = String(entity.id || '');
          if (!id || seen.has(id) || entity.isBot === true) continue;
          seen.add(id);
          targets.push(id);
        }
      } catch (e) {
        warnings.push('Не удалось получить список сотрудников для приглашения.');
        logSwallowed(e, 'Спор маркетплейса: список сотрудников роли');
      }
    }
    for (const id of targets.slice(0, MAX_ARBITERS)) {
      try {
        await addConversationMember(conversationId, id);
      } catch (e) {
        warnings.push('Часть сотрудников не добавлена в обсуждение (проверьте права).');
        logSwallowed(e, 'Спор маркетплейса: приглашение участника');
      }
    }
  } catch (e) {
    warnings.push('Не удалось пригласить операторов в обсуждение — историю они могут не увидеть.');
    logSwallowed(e, 'Спор маркетплейса: список ролей для приглашения');
  }
  return warnings;
}
